/* global localStorage */

import $ from "jquery";
import { trans } from "common/translate.js";

/**
 * Turn high contrast mode on
 *
 * @returns {undefined}
 */
function highContrastOn() {
  // Update body
  $("html").addClass("t-high-contrast");

  // Set local storage
  localStorage.highContrastMode = "true";

  // Set label(s)
  $(".js-hc-label")
    .text(trans("High contrast mode ON"));

  // Set button aria attributes
  $(".js-hc-toggle")
    .attr("aria-checked", "true");
 }

/**
 * Turn high contrast mode off
 *
 * @returns {undefined}
 */
function highContrastOff() {
  // Update body
  $("html").removeClass("t-high-contrast");

  // Set local storage
  localStorage.highContrastMode = "false";

  // Set label
  $(".js-hc-label")
    .text(trans("High contrast mode OFF"));

  // Set button aria attributes
  $(".js-hc-toggle")
    .attr("aria-checked", "false");
}

/**
 * Check in localStorage if high contrast mode needs to be turned on or off and
 * runs the function to make sure the DOM is up to date.
 *
 * @returns {undefined}
 */
export function highContrastCheck() {
  if (localStorage.highContrastMode === "true") {
    highContrastOn();
  } else {
    highContrastOff();
  }
}

/**
 * Check in localStorage if high contrast mode needs to be turned on or off and
 * toggle it accordingly
 *
 * @returns {undefined}
 */
export function highContrastToggle() {
  if (localStorage.highContrastMode === "true") {
    highContrastOff();
  } else {
    highContrastOn();
  }
}




// WEBPACK FOOTER //
// ./src/frontend/common/page/high-contrast.js